module.exports = __webpack_public_path__ + "static/media/Safina Siddiqui.994c0e38.jpg";